/**
 * Converts Bulgarian Lev (BGN) to Euro (EUR)
 * @param {string|number} bgnAmount
 * @returns {string} EUR formatted as "0.00"
 */
export function bgnToEur(bgnAmount) {
    const num = parseFloat(bgnAmount);
    if (isNaN(num)) return "0.00";

    const rate = 1.95583;
    const eur = num / rate;

    // Proper rounding: multiply → round → divide
    const rounded = Math.round(eur * 100) / 100;

    return rounded.toFixed(2);
}

/**
 * Converts Euro (EUR) to Bulgarian Lev (BGN)
 * @param {string|number} eurAmount
 * @returns {string} BGN formatted as "0.00"
 */
export function eurToBgn(eurAmount) {
    const num = parseFloat(eurAmount);
    if (isNaN(num)) return "0.00";

    const rate = 1.95583;
    const bgn = num * rate;

    // Proper rounding: multiply → round → divide
    const rounded = Math.round(bgn * 100) / 100;

    return rounded.toFixed(2);
}

export function toCurrency(amount, fractionalDigits = 2) {
    let num = parseFloat(amount);
    if (isNaN(num)) num = 0;
    const rounded = Math.round(num * 100) / 100;

    return rounded.toFixed(fractionalDigits);
}
